<template>
  <div id="app">
<!--    <img src="./assets/logo.png">-->
    <router-view v-if="isRouter"></router-view>
  </div>
</template>

<script>
export default {
  name: 'App',
  provide(){
    return{
      reload: this.reload
    }
  },
  data(){
    return{
      isRouter: true
    } 
  },
  created: function() {

    let Alanguage = window.sessionStorage.getItem('language')
    if(Alanguage==''||Alanguage==undefined){
      window.sessionStorage.setItem('language', '1')
    }else{
      window.sessionStorage.getItem('language')
    }
    this.language = window.sessionStorage.getItem('language')
   },
  methods:{
    reload(){
      this.isRouter = false
      this.$nextTick(function () {
        this.isRouter = true
      })
    }
  }
}
</script>

<style>
  a{color: #666;}
  a:hover {
      color: #666;
  }
ul{
  padding: 0;
  margin: 0;
}
ul li{
  padding: 0;
  margin: 0;
  list-style: none;
}
body{
  padding: 0;
  margin: 0;
}
p{
  padding: 0;
  margin: 0;
  white-space: pre-line;
}
h2{
  padding: 0;
  margin: 0;
}
h1, h2, h3, h4, h5, h6, p{
  padding: 0;
  margin: 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue